import { render, staticRenderFns } from "./buyingBehavior.vue?vue&type=template&id=42c9e8c2&scoped=true"
import script from "./buyingBehavior.vue?vue&type=script&lang=js"
export * from "./buyingBehavior.vue?vue&type=script&lang=js"
import style0 from "./buyingBehavior.vue?vue&type=style&index=0&id=42c9e8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c9e8c2",
  null
  
)

export default component.exports